import React from 'react';
import { Music2, Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Logo & Description */}
          <div className="col-span-1 md:col-span-1">
            <img 
              src="/logo-masterclass.png" 
              alt="Master Class Logo" 
              className="h-16 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Formando músicos de excelencia desde 2017. Tu pasión por la música comienza aquí.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4 flex items-center">
              <Music2 className="mr-2 text-amber-500" size={20} />
              Enlaces Rápidos
            </h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('inicio')}
                  className="text-gray-400 hover:text-amber-400 transition-colors text-sm"
                >
                  Inicio
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('sobre')}
                  className="text-gray-400 hover:text-amber-400 transition-colors text-sm"
                >
                  Sobre Nosotros
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('asignaturas')}
                  className="text-gray-400 hover:text-amber-400 transition-colors text-sm"
                >
                  Asignaturas
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('galeria')}
                  className="text-gray-400 hover:text-amber-400 transition-colors text-sm"
                >
                  Galería
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contacto')}
                  className="text-gray-400 hover:text-amber-400 transition-colors text-sm"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contáctanos</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>C/ Máximo Garcia Garrido 10-12</li>
              <li>48980 SANTURTZI - Bizkaia</li>
              <li className="mt-4">
                <a href="tel:+34644464599" className="hover:text-amber-400 transition-colors">
                  644 464 599
                </a>
              </li>
              <li>
                <a href="mailto:info@masterclassacademia.com" className="hover:text-amber-400 transition-colors">
                  info@masterclassacademia.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-500 text-sm flex items-center">
              © {currentYear} MASTER-CLASS. Todos los derechos reservados.
            </p>
            <p className="text-gray-500 text-sm flex items-center">
              Hecho con <Heart className="mx-1 text-amber-500" size={14} fill="currentColor" /> para la música
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
